import React,{Component} from 'react'
import $ from 'jquery'
import Users from './Users';
import Category from './Categroy';
import UserInfo from './UserInfo';
import Products from './Products';
import AddProduct from './AddProduct';
import Seller from './Seller';
import Orders from './Orders';
import Store from './Store';
import Riders from './Riders';
import Transactions from './Transactions';


class Dashboard extends Component {

  constructor(props) {
    super(props);

    this.state = {
       activePage:'seller',
       user_id:'',
       product_id:''
    };
}
  componentDidMount(){
  
  }
  componentDidUpdate(){
   

  }
  renderContent =()=>{

    const {activePage} = this.state;
    if(activePage === 'users'){
        return (<Users />);
    }else if(activePage === 'category'){
      return (<Category />);
    }else if(activePage === 'products'){
      return (<Products handlePages={this.handlePages} handleEditRequest={this.handleEditRequest} />);
    }else if(activePage === 'addProduct'){
      return (<AddProduct product_id={this.state.product_id} handleEditRequest={this.handleEditRequest} handlePages={this.handlePages} />);
    }else if(activePage === 'seller'){
      return (<Seller />);
    }else if(activePage === 'orders'){
      return (<Orders />);
    }else if(activePage === 'stores'){
      return (<Store />);
    }else if(activePage === 'riders'){
      return (<Riders />);
    }else if(activePage === 'transactions'){
      return (<Transactions />);
    }
  }
  handlePages =(page) =>{
       this.setState({activePage:page})
  }

  handleEditRequest =(id) =>{
    this.setState({product_id:id})
    if(id !== ''){
      this.handlePages('addProduct')
    }
  }
    render(){
   
        return(<>
    
        <div id="page_container" className="toggled">
                    <aside id="aside">
                        <ul className="nav">
                            {/* <li className="text-center user border-bottom ">
                                <a href="#" className="user_img" data-toggle="dropdown">
                                    <p><img  src="assests/images/contact_pic2.png" alt="img" /></p>
                                    <p><span>Admin</span></p>
                                </a>
                            </li> */}
                            {/* <li><a href="javascript:void(0)"><i className="fa fa-home"></i> <span>Dashboard</span></a></li> */}
                            <li><a href="javascript:void(0)"  onClick={()=>this.handlePages('seller')}><i className="icon-user icons"></i> <span>Seller</span></a></li>
                            <li className="active"><a  href="javascript:void(0)"onClick={()=> this.handlePages('users')}> <i className="icon-users icons"></i> <span>Users</span></a></li>
                            <li><a href="javascript:void(0)"  onClick={()=>this.handlePages('riders')}><i className="icon-target icons"></i> <span>Riders</span></a></li>
                            <li><a href="javascript:void(0)"  onClick={()=>this.handlePages('stores')}><i className="icon-pie-chart icons"></i> <span>Stores</span></a></li>
                            <li><a href="javascript:void(0)"  onClick={()=>this.handlePages('category')}><i className="icon-grid icons"></i> <span>Categories</span></a></li>
                            <li><a href="javascript:void(0)"  onClick={()=>this.handlePages('products')}><i className="icon-social-dropbox icons"></i> <span>Products</span></a></li>
                            <li><a href="javascript:void(0)"  onClick={()=>this.handlePages('orders')}><i className="icon-basket icons"></i> <span>Orders</span></a></li>
                            <li><a href="javascript:void(0)"  onClick={()=>this.handlePages('transactions')}><i className="fa fa-credit-card"></i> <span>Transactions</span></a></li>
                            {/* <li><a href="javascript:void(0)" ><i className="fa fa-home"></i> <span>Reports</span></a></li> */}
                        </ul>
                    </aside>
                    <div className="main_container">
                      {this.renderContent()}
                    </div>

                </div>
            
        </>)
    }
}
export default Dashboard